import { TPermissionSet, TPermission, TPermissionRequirement } from "../types/permissions";

export function matchesPermission(required: string, granted: string) {
    const r = required.split("::");
    const g = granted.split("::");
    if (r.length !== g.length) return false;
    for (let i = 0; i < r.length; i++) {
        if (r[i] === "*") continue;
        if (r[i] !== g[i]) return false;
    }
    return true;
}

export function hasPermission(
    required: TPermission,
    grantedSet: TPermissionSet
) {
    if (required.includes("*")) {
        for (const g of grantedSet) if (matchesPermission(required, g)) return true;
        return false;
    }
    return grantedSet.has(required);
}

export function satisfiesRequirement(
    req: TPermissionRequirement,
    grantedSet: TPermissionSet
) {
    if (typeof req === "string") {
        if ("noRestrictions::all" === req) return true;
        return hasPermission(req, grantedSet);
    }
    if ("any" in req) return req.any.some((p) => hasPermission(p, grantedSet));
    if ("all" in req) return req.all.every((p) => hasPermission(p, grantedSet));
    return false;
}
